<template>
  <div>
    <div class="elTabs">
      <div class="tabTitles">
        <div
            v-for="(item,index) in unreadCountList"
            class="title"
            :class="index===activeIndex?'active':''"
            @click="clearClick(item,index)"
        >
          <div>
            <p>{{ item.nickname }}</p>
            <span v-if="item.unreadCount>0"/>
          </div>
        </div>
      </div>
      <div class="tabsMain" v-if="tabList.length!==0">
        <el-row
            type="flex"
            class="row-bg imgType"
            justify="space-between"
            v-for="(item,index) in tabList"
            :key="index"
        >


          <el-col :span="5"
                  class="left"
                  v-if="item.kindTypeEnum==='CARD'&&item.content.card.imageUrl"
                  :style="{ backgroundImage: 'url(' + item.content.card.imageUrl + ')' }"
          >
          </el-col>
          <el-col :span="item.p4?19:24" class="right">
            <div class="rightTop">
              <div class="infoDiv">
                <p class="textImg"
                   v-if="item.kindTypeEnum==='TEXT'"
                   :style="{ backgroundImage: 'url(' + historyTextPng + ')' }"
                />
                <div class="title"
                     v-html="
                   item.kindTypeEnum==='CARD'?(item.content.card.title):
                   item.kindTypeEnum==='TEXT'?(item.content.text):
                   ''"
                ></div>
              </div>
              <div class="time" v-if="item.kindTypeEnum==='CARD'">{{ item.createdAt|formatDate }}</div>
            </div>
            <div class="rightMid"
                 :class="item.kindTypeEnum==='CARD'?'cardTypeEnum':''"
                 v-if="item.kindTypeEnum==='CARD'"
                 v-html="
                   item.kindTypeEnum==='CARD'?(item.content.card.body):
                   item.kindTypeEnum==='TEXT'?(item.content.text):
                   ''"></div>
            <div class="rightBot"
                 v-if="item.kindTypeEnum==='CARD'&&item.content.card.webLink"
                 @click="detailClick(item)"
            >查看详情>
            </div>
            <div class="timeText" v-if="item.kindTypeEnum==='TEXT'">{{ item.createdAt|formatDate }}</div>
          </el-col>
        </el-row>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryForm.page"
            :page-sizes="[5, 10, 15, 20, 30]"
            :page-size="queryForm.size"
            :layout='layout'
            :total="total">
        </el-pagination>
      </div>
      <EmptyData v-else/>
    </div>
  </div>
</template>

<script>
import {
  mesClearUnread,
  mesSearch,
  mesUnreadCount,
} from "@http/message";
import {mapState} from "vuex";
import EmptyData from "@com/EmptyData";
import {urlify} from "@/utils/utils";
export default {
  name: "history",
  components: {EmptyData},
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  data() {
    return {
      wenPng: require("@/assets/images/wen(1).png"),
      historyTextPng: require("@/assets/images/historyText.png"),
      layout: 'total, sizes, prev, pager, next, jumper',
      tabList: [],
      queryForm: {
        page: 1,
        size: 5,
      },
      total: 0,
      unreadCountList: [],
      activeIndex: 0,
      urlRosterId: ''
    }
  },
  methods: {
    handleSizeChange(val) {
      this.queryForm.size = val
      this.initList(this.queryForm.senderId)
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.initList(this.queryForm.senderId)
    },
    // 初始数据
    async initData() {
      let res = await mesUnreadCount()
      this.unreadCountList = res.sourceTypeUnreadList
      this.urlRosterId = this.$route.query.sysRosterId
      if (this.urlRosterId) {
        this.initList(this.urlRosterId)
        this.cleanUnread(this.urlRosterId)
        this.unreadCountList.forEach((item, index) => {
          if (item.sysRosterId === this.urlRosterId) {
            this.activeIndex = index
          }
        })
      } else if (res.sourceTypeUnreadList[0]) {
        this.initList(res.sourceTypeUnreadList[0].sysRosterId)
        this.cleanUnread(res.sourceTypeUnreadList[0].sysRosterId)
      }

    },
    // 卡片点击
    async clearClick(data, index) {
      this.activeIndex = index
      this.queryForm.size = 5
      this.queryForm.page = 1
      this.unreadCount()
      this.initList(data.sysRosterId)
      this.cleanUnread(data.sysRosterId)

      console.log(this.tabList.length);

    },
    // 列表
    async initList(senderId) {
      this.queryForm.senderId = senderId
      let res = await mesSearch(this.queryForm)
      this.tabList = res.data
      this.tabList.forEach(item => {
        if (item.kindTypeEnum === 'TEXT' && item.content.text) {
          item.content.text = urlify(item.content.text, 'textBlue')
        }
      })
      this.total = res.total
    },
    // 清除红点
    async cleanUnread(senderId) {
      mesClearUnread({senderId}).then(res => {
        if (res.code === 200) {
          this.unreadCount()
        }
      })
    },
    // 查看详情
    async detailClick(datq) {
      window.open(datq.content.card.webLink)
    },
    // 卡片信息
    async unreadCount() {
      let res = await mesUnreadCount()
      this.unreadCountList = res.sourceTypeUnreadList
    }
  },
  created() {
    this.initData()
  }
}
</script>

<style scoped lang="less">
.elTabs {
  font-size: 16px;
  .tabTitles {
    border-bottom: 1px solid #EEEEEE;

    .title {
      width: 158px;
      height: 42px;
      background: #EEEEEE;
      line-height: 42px;
      text-align: center;
      cursor: pointer;
      display: inline-block;
      position: relative;
      font-weight: 400;
    }

    .active {
      background: #fff;
      color: #1C94F3;
      font-weight: bold !important;
    }

    p {
      display: inline-block;
    }

    span {
      width: 6px;
      height: 6px;
      background: #EA0F0F;
      border-radius: 50%;
      display: inline-block;
      margin-bottom: 7px;
    }
  }

  .tabsMain {
    margin-top: 20px;

    .imgType {
      border: 1px solid #E9E9E9;
      width: 98%;
      min-height: 80px;
      margin-top: 20px;

      .left {
        height: auto;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: top;
        margin-top: 16px;
        margin-bottom: 16px;
        margin-left: 16px;
        width: 295px;
        height: 129px;
        //295 129
      }

      .right {
        padding: 10px 20px 20px 23px;
        position: relative;

        .rightTop {
          display: flex;
          justify-content: space-between;

          .title {
            font-weight: 550;
            color: #333333;
            //width: 80%;
            white-space: pre-wrap;
            line-height: 30px;
              /deep/ .textBlue {
              color: #1A64E5;
              text-decoration-line: underline;
              text-decoration-color: #1A64E5;
            }
          }

          .time {
            font-weight: 400;
            color: #999999;
            line-height: 30px;
          }

          .textImg {
            width: 16px;
            height: 16px;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            display: inline-block;
            float: left;
            margin-top: 6px;
            margin-right: 3px;
          }
          .infoDiv{
            flex: 1;
          }
        }

        .rightMid {
          font-weight: 400;
          color: #666666;
          margin: 10px 0 5px;
          white-space: pre-wrap;
        }

        .cardTypeEnum {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box; //将对象作为弹性伸缩盒子模型显示。
          -webkit-box-orient: vertical; // 从上到下垂直排列子元素
          -webkit-line-clamp: 5; //显示的行数
        }

        .rightBot {
          font-weight: 400;
          color: #1C94F3;
          cursor: pointer;
          left: 23px;
          bottom: 20px;
          margin-top: 14px;
        }

        .timeText{
          font-weight: 400;
          color: #999999;
          float: right;
        }
      }
    }

    /deep/ .el-pagination {
      float: right;
      margin: 32px 2% 80px 0;

      .el-select__caret {
        line-height: normal;
      }
    }
  }
}
</style>